import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarEditSolid = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M8.5 2H7V4H3V21H12V19.5H4.5V10H19.5V11H21V4H17V2H15.5V4H8.5V2Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.25 12.6893L14 18.9393V22H17.0607L23.3107 15.75L20.25 12.6893Z",
			fill: "currentColor"
		})
	]
});
export default SvgCalendarEditSolid;
